import {
  CSSObject,
  Theme,
  styled,
  Drawer as MuiDrawer,
  ListItemButton,
  ListItemIcon,
} from '@mui/material';



const drawerWidth = 180;

export const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

export const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(7)} + 1px)`,
  },
});

export const DrawerHeader = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  height: '40px',
  minHeight: '40px',
  padding: '0 4px',
}));

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: prop => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  zIndex: 1201,
  '& .MuiDrawer-paper': {
    borderRight: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none',
    borderRadius: 0,
  },
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': {
      ...openedMixin(theme),
      borderRight: `1px solid ${theme.palette.divider}`,
      boxShadow: 'none',
      borderRadius: 0,
    },
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': {
      ...closedMixin(theme),
      borderRight: `1px solid ${theme.palette.divider}`,
      boxShadow: 'none',
      borderRadius: 0,
    },
  }),
}));

export const CustomListItemButton = styled(ListItemButton, {
  shouldForwardProp: prop => prop !== 'isActive' && prop !== 'open',
})<any>(({ theme, isActive, open }) => ({
  minHeight: 36,
  justifyContent: open ? 'initial' : 'center',
  marginLeft: theme.spacing(1.5),
  marginRight: theme.spacing(1),
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
  paddingRight: theme.spacing(1.5),
  paddingLeft: theme.spacing(1.5),
  backgroundColor: isActive ? theme.palette.background.tertiary : 'inherit',
  borderRadius: '4px',
}));

export const CustomListItemIcon = styled(ListItemIcon, {
  shouldForwardProp: prop => prop !== 'isActive',
})<{ isActive: boolean }>(({ theme, isActive }) => ({
  minWidth: 0,
  marginRight: '8px',
  justifyContent: 'center',
  color: isActive ? theme.palette.primary.main : 'inherit',
}));
